import { render } from "./SectionPaymentPreparation.vue?vue&type=template&id=52e7bdcd&scoped=true"
import script from "./SectionPaymentPreparation.vue?vue&type=script&lang=js"
export * from "./SectionPaymentPreparation.vue?vue&type=script&lang=js"

import "./SectionPaymentPreparation.vue?vue&type=style&index=0&id=52e7bdcd&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e7bdcd"]])

export default __exports__